import { render } from "./homeStudioDetail.vue?vue&type=template&id=4d490a5a&scoped=true"
import script from "./homeStudioDetail.vue?vue&type=script&lang=js"
export * from "./homeStudioDetail.vue?vue&type=script&lang=js"

import "./homeStudioDetail.vue?vue&type=style&index=0&id=4d490a5a&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d490a5a"]])

export default __exports__